export enum ParentParameters {
	ID = 7,
	SUBJECTAREA = 1,
	PROJECTTYPE = 11,
	PRINCIPLIMPLEMENTING_APF1 = 17,
	CATIMPLEMENTINGINSTITUTION_APF1 = 21,
	IDENTITY_PROOF = 26,
	PROPOSED_COST_ITEM = 30,
	APPLYONLINE_STAGE = 79,
	EXPERT_CATEGORIES = 88,
	BANK_ACCOUNT_TYPES = 128,
	BUDGET_TYPE = 131,
	UNITS = 136,
	APPLICATION_STATUS = 147
}

export enum statusCode {
	SUCCESS = 200,
	ERROR = 201,
	ACCEPTED = 202,
	BAD_REQUEST = 400,
	UNAUTHORIZED = 401,
	PAYMENT_REQUIRED = 402,
	FORBIDDEN = 403,
	NOT_FOUND = 404,
	REQUEST_TIMEOUT = 408,
	INTERNAL_SERVER_ERROR = 500,
	BAD_GATEWAY = 502,
	SERVICE_UNAVAILABLE = 503,
	GATEWAY_TIMEOUT = 504
}

export enum documentType {
	SignedDocument = 1,
	SanctionLatter = 2
}

export enum progressReportStatus {
	approve = 1,
	reject = 2,
	pending = 3
}

export enum applicationFrom {
	MY_APPLICATION = 1,
	MEETING_AGENDA = 2,
	MIS_REPORT 	= 3
}